module.exports = __webpack_public_path__ + "static/media/overcast.20ec27f6.svg";